import { hotRank } from "@/mocks/gua";

export default function HotRank() {
  return (
    <section className="mx-auto max-w-6xl px-4 pt-12 md:px-6 md:pt-16">
      <div className="mb-5 flex items-center justify-between">
        <div>
          <h3 className="flex items-center gap-2 text-lg font-bold text-foreground-950 md:text-xl">
            <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-fire-fill" />
            </span>
            全网热议榜
          </h3>
          <p className="mt-1.5 text-xs text-foreground-600 md:text-sm">
            标题优先的速览 —— 只给你关键词与热度，点标题再看全文。
          </p>
        </div>
        <a href="#" className="inline-flex items-center gap-1 whitespace-nowrap text-sm text-foreground-700 hover:text-accent-700">
          换一批 <i className="ri-refresh-line" />
        </a>
      </div>

      <div className="grid grid-cols-1 gap-x-8 lg:grid-cols-2">
        {hotRank.map((it) => (
          <a
            key={it.id}
            href="#"
            className="group flex items-center gap-4 border-b border-background-200 py-3.5 first:pt-1"
          >
            <span className="w-8 shrink-0 text-center font-black text-background-300 transition-colors group-hover:text-accent-500">
              {it.rank}
            </span>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-600 md:text-[15px]">
                {it.title}
              </p>
              <p className="mt-1 text-xs text-foreground-600">
                关键词：{it.keyword}
              </p>
            </div>
            <div className="shrink-0 text-right">
              <p className="text-xs font-semibold text-foreground-800">{it.heat}</p>
              <p
                className={
                  it.rise
                    ? "mt-0.5 inline-flex items-center gap-0.5 text-xs font-medium text-primary-500"
                    : "mt-0.5 inline-flex items-center gap-0.5 text-xs font-medium text-foreground-400"
                }
              >
                <i className={it.rise ? "ri-arrow-up-line" : "ri-arrow-down-line"} />
                {it.trend}
              </p>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}